import styled from "styled-components";
import chefImg from "../../assets/chef.png";
import deliveryImg from "../../assets/delivery.jpg";
import PageHeader from "../../features/shared/PageHeader";

const CardHeading = styled.h2`
  font-size: 36px;
  line-height: 1.15;
  font-weight: 800;
  color: #1b6dc1;
`;

const CardTextHighlight = styled.strong`
  color: #1b6dc1;
`;

export default function EarnMoney() {
  return (
    <section className="page-navbar-space container">
      <div className="">
        <PageHeader>Welcome to OwnFood</PageHeader>

        <div className="row align-items-center my-5 pb-4">
          <div className="col-12 col-md-4 pb-3 pb-md-0">
            <img src={chefImg} alt="Cooking partner" className="img-fluid w-100 rounded-4" />
          </div>
          <div className="col-12 col-md-8">
            <CardHeading>
              Your Ultimate Food Experience!
            </CardHeading>
            <p className="lead mb-3">
              For Cooking Enthusiasts: Share Your Recipes and Sell Your
              Delicious Creations!
            </p>
            <p style={{ fontSize: '16px', fontWeight: 'normal', lineHeight: '1.6' }}>
              Do you love cooking and have a passion for sharing your culinary
              creations? With OwnFood, you can turn your kitchen into a hub of
              delicious possibilities!
              <br />
              <br />
              <CardTextHighlight>Sell Your Signature Recipes:</CardTextHighlight> Share your unique
              recipes with food lovers and earn money.
              <br />
              <CardTextHighlight>Offer Your Homemade Meals:</CardTextHighlight> Cook and sell your
              freshly prepared meals to local customers.
              <br />
              <CardTextHighlight>Showcase Your Expertise:</CardTextHighlight> Build your culinary
              brand by sharing cooking tips and videos.
              <br />
              <CardTextHighlight>Connect with Food Enthusiasts:</CardTextHighlight> Reach a
              community that appreciates homemade meals.
              <br />
              <br />
              At OwnFood, we help you focus on doing what you love—cooking!
              Let us take care of the rest.
            </p>
          </div>
        </div>

        <div className="row align-items-center mb-5">
          <div className="col-12 col-md-8 order-2 order-md-1">
            <CardHeading>
              Earn Money by Delivering Food!
            </CardHeading>
            <p className="mt-3" style={{ fontSize: '16px', fontWeight: 'normal', lineHeight: '1.6' }}>
              Looking for a flexible way to earn money? Join the OwnFood
              Delivery Partner program and help bring delicious meals to
              people’s doorsteps.
              <br />
              <br />
              <CardTextHighlight>Be Your Own Boss:</CardTextHighlight> Choose your working hours and
              deliver whenever it’s convenient.
              <br />
              <CardTextHighlight>Earn More on Every Ride:</CardTextHighlight> Get paid for each
              delivery you complete.
              <br />
              <CardTextHighlight>Support Local Businesses:</CardTextHighlight> Help talented chefs
              and home cooks reach more customers.
              <br />
              <CardTextHighlight>Easy to Get Started:</CardTextHighlight> Register online, verify
              your details, and start earning.
              <br />
              <br />
              With OwnFood, you don’t just deliver food—you deliver happiness.
            </p>
          </div>
          <div className="col-12 col-md-4 order-1 order-md-2 pb-3 pb-md-0">
            <img src={deliveryImg} alt="Delivery partner" className="img-fluid w-100 rounded-4" />
          </div>
        </div>

        <div className="pt-5 pb-5 pb-md-0">
          <p className="text-center fs-6 fw-bold" style={{ color: '#1b6dc1' }} >
            From Kitchen to Doorstep, Connecting Food Lovers Everywhere!
          </p>
          <p className="text-center fs-6 fw-normal" style={{ color: '#1b6dc1' }}>
            Whether you’re a chef selling your recipes or meals, or a delivery
            rider delivering food and earning, OwnFood is the platform where
            opportunities meet passion.
          </p>
        </div>
      </div>
    </section>
  );
};